import { useLogosBancos } from '../../config/constants';
import { Trash2,LayoutList } from 'lucide-react';
import React, { useState, useEffect,useMemo} from 'react';

const ListaCuentasBancarias = ({ cuentas ,onDeleteCuenta }) => {

  const {getBancoLogo} = useLogosBancos();

  return (
    <div className="flex flex-col w-full space-y-3">
      {cuentas.map((cuenta, index) => {
        
        // 1. OBTENEMOS EL LOGO AQUÍ (DENTRO DEL MAP)
        // Esto se ejecuta para cada cuenta individualmente
        const logoUrl = getBancoLogo(cuenta.tipoCuenta);

        return (
          <div key={index} className="flex items-center justify-between p-4 border bg-white rounded-lg mb-3 shadow-sm">
            <div className="flex items-center">
              
              {/* 2. CONTENEDOR DE LA IMAGEN */}
              <div className="w-12 h-12 flex-shrink-0 bg-white rounded-lg border border-gray-200 flex items-center justify-center overflow-hidden p-2 mr-4">
                <img 
                  src={logoUrl}
                  alt={cuenta.tipoCuenta} 
                  className="w-full h-full object-contain" 
                />
              </div>
              
              <div>
                <div className="font-medium text-gray-800 capitalize">{cuenta.tipoCuenta}</div>
                <div className="text-sm text-gray-500 font-mono">{cuenta.numeroCuenta}</div>
              </div>
            </div>

            <div className="flex items-center space-x-2">
              <button 
                className="p-2 text-blue-500 hover:bg-blue-50 rounded-full transition-colors"
                onClick={() => navigator.clipboard.writeText(cuenta.numeroCuenta)}
                title="Copiar número"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                </svg>
              </button>

              {onDeleteCuenta && (
                <button 
                  className="p-2 text-red-500 hover:bg-red-50 rounded-full transition-colors"
                  onClick={() => onDeleteCuenta(index)}
                  title="Eliminar cuenta"
                >
                  <Trash2 className="w-5 h-5" />
                </button>
              )}

            </div>
          </div>
        );
      })}
    </div>
  );

};

export default ListaCuentasBancarias;